import { createSlice } from '@reduxjs/toolkit'
import { getAllChats, getChatLanguageRooms } from 'redux-store/thunk/chat.thunk'

const initialState = {
  allChats: null,
  languageRooms: null
}

const {
  actions: {
    setAllChatsData
  },
  reducer
} = createSlice({
  name: 'chat',
  initialState,
  reducers: {

    setAllChatsData: (state, action) => {
      return {
        ...state,
        allChats: {
          ...state.allChats,
          messages: [...state.allChats.messages, action.payload]
        }
      }
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllChats.fulfilled, (state, action) => ({
        ...state,
        allChats: { ...action.payload, messages: action.payload?.messages?.reverse() }
      }))
      .addCase(getChatLanguageRooms.fulfilled, (state, { payload }) => ({
        ...state,
        languageRooms: payload
      }))
  }
})

export default reducer
export {
  setAllChatsData
}
